import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import {  ExchangeMemebersFilter } from "../types";

export const getExchangeMembersExcel = (
  user: User,
  filter: ExchangeMemebersFilter
  ) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getexchangememberxls",
    params: {
      userid: user.userId,
      brokerId: filter?.brokerId,
      cliStatus: filter?.cliStatus,    
      dateActFrom: filter?.dateactfrom,
      dateActTo: filter?.dateactto,
    },
  });
};

export default getExchangeMembersExcel;
